// TODO(@alecglassford): Update the Rails template so that both Rails apps and
// Baker apps can use a the same "hydrate" script (I think `hydrate-baker.mjs`
// will work best.

/**
 * Hydrates all server-side rendered (SSRed) Svelte component instances in the
 * DOM.
 *
 * Expects the page to contain
 * `<script type="application/json" id="svelte-configs">...</script>` with
 * config info for each component instance.
 *
 * Expects each SSRed component instance in the DOM to be prefixed with
 * `<script type="text/plain" data-svelte-hydrate-id="INDEX"></script>` (where
 * `INDEX` corresponds to the corresponding entry in the config array) and
 * postfixed with `<!-- svelte-component-end -->`.
 *
 * @param {{[componentName: string]: import("svelte").ComponentType}} componentClasses Collection
 *     of
 *     [client-side](https://svelte.dev/docs#run-time-client-side-component-api)
 *     Svelte components. All components that have been SSRed into the DOM must
 *     be represented in this object.
 */
export const hydrate = function hydrateAllComponentsOnPage(componentClasses) {
    /** @type import("./generate-ssr-output.mjs").ComponentConfig[] */
    const configs = JSON.parse(
        document.getElementById("svelte-configs").textContent
    );

    // Each SSRed component instance has a startMarker right before it.
    /** @type {NodeListOf<HTMLScriptElement>} */
    const startMarkers = document.querySelectorAll(
        'script[type="text/plain"][data-svelte-hydrate-id]'
    );

    startMarkers.forEach((startMarker) => {
        // Insert an empty div after the startMarker (before the SSRed content)
        const tempParent = document.createElement("div");
        startMarker.after(tempParent);

        // For each top-level element that comprises the SSRed content, move it
        // into the temporary <div>. Stop when we see
        // <!-- svelte-component-end --> (which appears after SSRed content).
        let currentElem = tempParent.nextSibling;
        let nextElem;
        while (
            !(
                currentElem.nodeType === Node.COMMENT_NODE &&
                currentElem.nodeValue === "svelte-component-end"
            )
        ) {
            nextElem = currentElem.nextSibling;
            tempParent.appendChild(currentElem);
            currentElem = nextElem;
        }

        // Hydrate the div that contains all our SSR content
        const index = Number(startMarker.dataset.svelteHydrateId);
        const {
            component_name: componentName,
            props,
            context_array: contextArray,
        } = configs[index];
        const Component = componentClasses[componentName];
        // https://svelte.dev/docs#run-time-client-side-component-api
        /* eslint-disable-next-line no-new -- Svelte API uses `new` to
            instantiate component, but we have no need to keep a reference to
            the instance at the moment. May change in the future. */
        new Component({
            hydrate: true,
            target: tempParent,
            props,
            context: new Map(contextArray),
        });

        // Remove the parent div (but keep the children)
        tempParent.replaceWith(...tempParent.children);
    });
};
